import { API_endpoints } from "../config";

export const statistic2 = async (startDate = "", endDate = ""): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic2, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ startDate, endDate }),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 2 Daten.");
        }
        const data = await response.json();
        console.log(data)
        return data;



    } catch (error) {
        console.error("Fehler beim Laden von statistik 2 Daten:", error);
    }
};
